import { render } from "./Help.vue?vue&type=template&id=5d3083b1&scoped=true&ts=true"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"

import "./Help.vue?vue&type=style&index=0&id=5d3083b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3083b1"]])

export default __exports__